/* @flow */
import React from 'react';
import loadable from '@loadable/component';
import type { TMortgageFormCallbackData } from '../../types/mortgage';
import { sendGTMAnalytics } from '../../utils/tagManager';
import ModalCallbackDeveloper from '../ModalCallbackDeveloper';
import ModalCallbackAdvert from '../ModalCallbackAdvert/ModalCallbackAdvert';

const CallbackForm = loadable(() => import('../CallbackModalForm'), { fallback: null, ssr: false });
const ModalCallbackForm = loadable(() => import('../ModalCallbackForm'), { fallback: null, ssr: false });

type TProps = {
	modalName:
		| 'view'
		| 'callback'
		| 'mortgage'
		| 'loyalty'
		| 'innerCallback'
		| 'outerCallbackDeveloper'
		| 'outerCallbackAdvert',
	apartId?: string,
	mortgageData?: TMortgageFormCallbackData,
	modalTitle?: string | null,
	userId?: number,
	handleCallbackModal?: () => {},
};

const CallbackPopupSwitcher = ({
	modalName,
	modalTitle,
	mortgageData,
	apartId,
	userId,
	handleCallbackModal,
}: TProps) => {
	const getModalContent = () => {
		let modalContentComponent;

		switch (modalName) {
			case 'view':
				modalContentComponent = <CallbackForm callbackType="view" handleTitle={modalTitle} apartId={apartId} />;
				break;
			case 'callback':
				modalContentComponent = (
					<CallbackForm callbackType="callback" handleTitle={modalTitle} apartId={apartId} />
				);
				break;
			case 'loyalty':
				modalContentComponent = (
					<CallbackForm callbackType="loyalty" handleTitle={modalTitle} userId={userId} />
				);
				break;
			case 'mortgage':
				modalContentComponent = (
					<CallbackForm
						callbackType="mortgage"
						mortgageData={mortgageData}
						handleTitle={modalTitle}
						apartId={apartId}
					/>
				);
				break;
			case 'innerCallback':
				modalContentComponent = <ModalCallbackForm apartId={apartId} />;
				break;
			case 'outerCallbackDeveloper':
				modalContentComponent = <ModalCallbackDeveloper handlerModalToggle={handleCallbackModal} />;
				break;
			case 'outerCallbackAdvert':
				modalContentComponent = <ModalCallbackAdvert handlerModalToggle={handleCallbackModal} />;
				break;
			default:
				modalContentComponent = null;
		}
		return modalContentComponent;
	};

	switch (modalName) {
		case 'callback':
		case 'innerCallback':
			sendGTMAnalytics({
				event: 'customTrackEvent',
				eventCategory: 'zayavka_na_zvonok_cta',
				eventAction: 'click_on_the_link',
			});
			break;
		case 'view':
			sendGTMAnalytics({
				event: 'customTrackEvent',
				eventCategory: 'zapis_na_prosmotr',
				eventAction: 'click_on_the_link',
			});
			break;
		case 'loyalty':
			sendGTMAnalytics({
				event: 'customTrackEvent',
				eventCategory: 'programma-loyalnosti',
				eventAction: 'click_on_the_link',
			});
			break;
		case 'mortgage':
			sendGTMAnalytics({
				event: 'customTrackEvent',
				eventCategory: 'zayavka_na_ipoteky',
				eventAction: 'click_on_the_link',
			});
			break;
		case 'outerCallbackDeveloper':
			sendGTMAnalytics({
				event: 'customTrackEvent',
				eventCategory: 'open_modal_developer_callback',
				eventAction: 'click_on_the_link',
			});
			break;
		case 'outerCallbackAdvert':
			sendGTMAnalytics({
				event: 'customTrackEvent',
				eventCategory: 'open_modal_advert_callback',
				eventAction: 'click_on_the_link',
			});
			break;
		default:
			return null;
	}

	return getModalContent();
};

CallbackPopupSwitcher.defaultProps = {
	mortgageData: {},
	modalTitle: null,
	apartId: null,
	userId: null,
	handleCallbackModal: undefined,
};

export default CallbackPopupSwitcher;
